import { ImagePaths } from '../../lib/imageUrls.js';

export const cloudSecurityArchitect = {

    id: 5,
    slug: 'cloud-security-architect',
    ogImage: '/og/courses/cloud-security-architect.jpg',
    courseCode: 'CLOUD-SEC-ARCH-001',
    title: 'Cloud Security Architect',
    subtitle: 'Secure cloud environments across AWS, Azure, and GCP',
    duration: '55 hours',
    students: 'New',
    level: 'Advanced',
    image: ImagePaths.COURSE_3,
    shortDescription: 'CLOUD-SEC-ARCH-001 — multi-cloud security architecture covering AWS, Azure and GCP identity, workload and compliance controls for senior architects.',
    price: {
      aud: 2299,
      currency: 'AUD',
      earlyBird: 1899
    },
    stripeConfig: {
    priceId: 'price_1SdKRRKu1nyc322Uyfju7A2j',
    productId: 'prod_TaVSgHSCO6pDqd'
  },
    
    overview: 'Become a cloud security architect with expertise across major cloud platforms. Learn to design, implement, and manage secure cloud architectures that meet enterprise security and compliance requirements.',
    
    outcomes: [
      'Design secure multi-cloud architectures',
      'Implement cloud-native security controls',
      'Manage identity and access in the cloud',
      'Secure containerised and serverless workloads',
      'Implement cloud security monitoring and compliance',
      'Lead cloud security transformation projects'
    ],
    
    audience: [
      'Security architects moving to cloud',
      'Cloud engineers focusing on security',
      'Senior security professionals',
      'Solution architects with security responsibilities',
      'Enterprise security leaders'
    ],
    
    prerequisites: [
      'Strong security fundamentals',
      'Experience with at least one cloud platform',
      'Understanding of networking and infrastructure',
      'Familiarity with DevOps practices'
    ],
    
    modules: [
      {
        title: 'Cloud Security Foundations',
        duration: '10 hours',
        topics: [
          'Shared responsibility model',
          'Cloud security frameworks',
          'Security architecture patterns',
          'Multi-cloud strategies'
        ]
      },
      {
        title: 'Identity and Access Management',
        duration: '12 hours',
        topics: [
          'Cloud IAM best practices',
          'Federated identity and SSO',
          'Privileged access management',
          'Service accounts and workload identity'
        ]
      },
      {
        title: 'Infrastructure Security',
        duration: '11 hours',
        topics: [
          'Network security in cloud',
          'Encryption and key management',
          'Security groups and firewalls',
          'DDoS protection strategies'
        ]
      },
      {
        title: 'Application Security',
        duration: '11 hours',
        topics: [
          'Container security (Kubernetes)',
          'Serverless security',
          'API security',
          'DevSecOps integration'
        ]
      },
      {
        title: 'Governance and Compliance',
        duration: '11 hours',
        topics: [
          'Cloud security posture management',
          'Compliance automation',
          'Logging and monitoring',
          'Incident response in cloud'
        ]
      }
    ],
    
    format: {
      type: 'Instructor-led cohort program',
      includes: [
        '55 hours of expert instruction',
        'Multi-cloud lab environments',
        'Weekly live sessions',
        'Real-world architecture projects',
        'Certification preparation (AWS, Azure, GCP)',
        '12 months access plus alumni network'
      ]
    },
    
    nextIntake: {
      date: 'Register your interest — we will confirm the next cohort',
      details: 'Limited to 15 participants for personalised mentorship'
    },
    
    faqs: [
      {
        question: 'Which cloud platforms are covered?',
        answer: 'We cover AWS, Microsoft Azure, and Google Cloud Platform comprehensively, with focus on multi-cloud security strategies.'
      },
      {
        question: 'Will this help me get cloud certifications?',
        answer: 'Yes, this course prepares you for AWS Security Specialty, Azure Security Engineer, and GCP Professional Cloud Security Engineer certifications.'
      },
      {
        question: 'Is hands-on experience included?',
        answer: 'Absolutely. You\'ll complete extensive labs and projects across all three major cloud platforms.'
      }
    ]
};
